export const SOUND_PREFS_KEY = 'NotificationSoundPreferences'
export const MIN_GAP_MS = 350
